import React, { useEffect, useRef } from "react";

import Spinner from "./Spinner";

/**
 * Shown when an SSO signup is detected to belong to an existing account. The user chooses whether
 * to create a new organisation for their existing account or simply log in.
 */
const ExistingAccountPrompt = ({ busy, error, onConfirm, onDecline }) => {
    const confirmRef = useRef(null);
    const isBusy = Boolean(busy); // busy is "create" | "login" | null

    // Move focus into the dialog on open and restore it to the previously focused element on close.
    useEffect(() => {
        const previouslyFocused = document.activeElement;
        confirmRef.current?.focus();
        return () => {
            if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus();
        };
    }, []);

    return (
        <div className="registration-prompt-overlay" data-cy="registration-existing-account-prompt">
            <div
                className="registration-prompt"
                role="dialog"
                aria-modal="true"
                aria-labelledby="registration-prompt-title"
                aria-describedby="registration-prompt-text"
            >
                <h2 className="registration-prompt__title" id="registration-prompt-title">
                    Konto bereits vorhanden
                </h2>
                <p className="registration-prompt__text" id="registration-prompt-text">
                    Dieses Konto existiert bereits. Möchtest du wirklich eine neue Organisation erstellen, anstatt dich
                    anzumelden?
                </p>

                {error && (
                    <p className="registration-input__error" role="alert">
                        {error}
                    </p>
                )}

                <button
                    type="button"
                    className="registration-cta"
                    onClick={onConfirm}
                    disabled={isBusy}
                    ref={confirmRef}
                    data-cy="registration-prompt-create-org"
                >
                    {busy === "create" ? (
                        <>
                            <Spinner /> Wird erstellt …
                        </>
                    ) : (
                        "Neue Organisation erstellen"
                    )}
                </button>
                <button
                    type="button"
                    className="registration-sso"
                    onClick={onDecline}
                    disabled={isBusy}
                    data-cy="registration-prompt-login"
                >
                    {busy === "login" ? (
                        <>
                            <Spinner /> Anmeldung läuft …
                        </>
                    ) : (
                        "Stattdessen anmelden"
                    )}
                </button>
            </div>
        </div>
    );
};

export default ExistingAccountPrompt;
